(function () {
  'use strict';
  // Fixed Santiago deadlines (UTC-03 on both dates), shared by home and collection.
  // These are campaign deadlines, never a per-visitor/session countdown.
  var ORIGINAL_END = Date.parse('2026-10-07T23:59:00-03:00');
  var EXTENDED_END = Date.parse('2026-10-09T23:59:00-03:00');
  var FINAL_END = Date.parse('2026-10-11T23:59:00-03:00');
  function stateAt(now) {
    var phase = now < ORIGINAL_END ? 'live' : now < EXTENDED_END ? 'extended' : now < FINAL_END ? 'final' : 'ended';
    var end = phase === 'live' ? ORIGINAL_END : phase === 'extended' ? EXTENDED_END : FINAL_END;
    var seconds = phase === 'ended' ? 0 : Math.max(0, Math.ceil((end - now) / 1000));
    return {phase:phase, end:end, seconds:seconds, hours:Math.floor(seconds / 3600), minutes:Math.floor(seconds / 60) % 60, remainder:seconds % 60, lastHour:seconds > 0 && seconds <= 3600};
  }
  if (typeof document === 'undefined') {
    if (typeof module !== 'undefined') module.exports = {stateAt:stateAt, originalEnd:ORIGINAL_END, extendedEnd:EXTENDED_END, finalEnd:FINAL_END};
    return;
  }
  var words = {
    live: {status:'CUENTA REGRESIVA CYBER', heading:'El Cyber se apaga en…', deadline:'Hoy, 7 oct. · 23:59 h Chile', speech:'¡APURATEE!', cta:'Aprovechar las ofertas', sub:'Aprovecha las ofertas antes del cierre de hoy a las 23:59.'},
    extended: {status:'CYBER EXTENDIDO', heading:'¡Extendimos el Cyber!', deadline:'Hasta el viernes 9 oct. · 23:59 h Chile', speech:'¡Nos extendimos!', cta:'Ver ofertas extendidas', sub:'¡Extendimos el Cyber hasta el viernes 9 de octubre a las 23:59!'},
    final: {status:'EXTENSIÓN FINAL', heading:'La última oportunidad.', deadline:'Domingo 11 oct. · 23:59 h Chile', speech:'¡¡APROVECHEN!!', cta:'Aprovechar la última extensión', sub:'Última extensión: hasta el domingo 11 de octubre a las 23:59. Esta vez sí se termina.'},
    ended: {status:'GRACIAS POR ACOMPAÑARNOS', heading:'Este Cyber terminó', deadline:'Nos vemos en la próxima aventura.', speech:'¡Gracias por venir!', cta:'Ver productos', sub:'El Cyber ha finalizado. Descubre todos nuestros productos.'}
  };
  function pad(n) { return String(n).padStart(2,'0'); }
  function boot() {
    var template = document.getElementById('cmomo-console-template');
    var root = document.querySelector('.sp4c-chero.sp4c-cneon') || document.querySelector('[data-cyber-lab]');
    if (!template || !root || root.hasAttribute('data-cmomo-root') || root.hasAttribute('data-cf-campaign')) return;
    var home = root.classList.contains('sp4c-cneon');
    var mount = home ? root.querySelector('.sp4c-cneon__action') : root.querySelector('.sp4c-coll__header > .sp4c-coll__inner');
    if (!mount) return;
    root.setAttribute('data-cmomo-root','');
    // Claim the mascot before legacy DOMContentLoaded handlers; never stack two Momos.
    if (home) {
      root.setAttribute('data-cyber-panda','idle');
      root.setAttribute('data-cyber-power','idle');
    } else {
      root.setAttribute('data-lab-ready','');
      root.querySelectorAll('.cyber-lab-momo,.cyber-finale-lab-label').forEach(function(el){el.remove();});
    }
    var panel = template.content.firstElementChild.cloneNode(true);
    panel.classList.add(home ? 'cmomo-console--home' : 'cmomo-console--collection');
    if (home) mount.insertBefore(panel,mount.firstChild); else mount.appendChild(panel);
    var mascot = panel.querySelector('.cmomo-mascot'), speech = panel.querySelector('[data-cmomo-speech]');
    var timer = panel.querySelector('.cmomo-digits'), announcement = panel.querySelector('[data-cmomo-announcement]');
    var digits = ['hours','minutes','seconds'].map(function(key){return panel.querySelector('[data-cmomo-'+key+']');});
    var cta = home ? root.querySelector('.sp4c-cneon__cta') : panel.querySelector('[data-cmomo-cta]');
    var target = home ? '/collections/cyber' : '#cmomo-ofertas';
    var productBody = !home && root.querySelector('.sp4c-coll__body');
    if (productBody) { if (!productBody.id) productBody.id='cmomo-ofertas'; target='#'+productBody.id; }
    if (cta) cta.href=target;
    var reduce = matchMedia('(prefers-reduced-motion: reduce)'), phase=null, visible=true, motionTimer, speechTimer, first=true;
    var sticky = document.createElement('aside');
    sticky.className='cmomo-sticky';sticky.setAttribute('aria-label','Cyber SoyMomo');
    var mini = mascot.querySelector('svg').cloneNode(true);
    // Avoid duplicate SVG clipPath IDs in the compact copy.
    mini.querySelectorAll('[id]').forEach(function(el){var id=el.id;el.id=id+'-mini';mini.querySelectorAll('[clip-path]').forEach(function(node){if(node.getAttribute('clip-path')==='url(#'+id+')')node.setAttribute('clip-path','url(#'+id+'-mini)');});});
    sticky.appendChild(mini);
    var stickyLabel=document.createElement('span'),stickyTime=document.createElement('strong'),stickyLink=document.createElement('a');
    stickyLink.href=target;stickyLink.textContent='Ver ofertas →';stickyTime.setAttribute('aria-hidden','true');
    sticky.appendChild(stickyLabel);sticky.appendChild(stickyTime);sticky.appendChild(stickyLink);document.body.appendChild(sticky);
    // Only local QA fixtures can simulate time. Production ignores every query parameter.
    var localPreview = /^(localhost|127\.0\.0\.1)$/.test(location.hostname) && document.documentElement.getAttribute('data-cmomo-preview-now');
    var previewStart=localPreview ? Date.parse(localPreview) : NaN, loadedAt=Date.now();
    function now() {return Number.isFinite(previewStart) ? previewStart+(Date.now()-loadedAt) : Date.now();}
    function settle(){clearTimeout(motionTimer);panel.setAttribute('data-cmomo-motion','idle');root.setAttribute('data-cmomo-mood','idle');}
    function animate(name) {
      if (reduce.matches || document.hidden || !visible) {settle();return;}
      clearTimeout(motionTimer);panel.setAttribute('data-cmomo-motion',name);root.setAttribute('data-cmomo-mood',name);
      motionTimer=setTimeout(settle,name==='shout'?2400:name==='power'?3200:1600);
    }
    function say(text,persistent) {
      clearTimeout(speechTimer);speech.textContent=text;panel.setAttribute('data-cmomo-speak','');
      if (!persistent) speechTimer=setTimeout(function(){panel.removeAttribute('data-cmomo-speak');speech.textContent=words[phase].speech;},3500);
    }
    function applyPhase(state) {
      var w=words[state.phase],changed=phase!==null;
      phase=state.phase;panel.setAttribute('data-cmomo-phase',phase);root.setAttribute('data-cmomo-phase',phase);
      panel.querySelector('[data-cmomo-heading]').textContent=w.heading;
      panel.querySelector('[data-cmomo-deadline]').textContent=w.deadline;
      speech.textContent=w.speech;clearTimeout(speechTimer);panel.removeAttribute('data-cmomo-speak');
      if (cta) {cta.textContent=w.cta+' →';if(phase==='ended')cta.href=home?'/collections/all':target;}
      stickyLabel.textContent=phase==='final'?'Extensión final':phase==='extended'?'Cyber extendido':'Cyber termina en';
      stickyLink.textContent=phase==='extended'?'Ver ofertas →':phase==='ended'?'Ver productos →':'Ver ofertas →';
      if(home){
        var sub=root.querySelector('.sp4c-cneon__sub'),status=root.querySelector('.sp4c-cneon__status');
        if(sub)sub.textContent=w.sub;
        if(status)status.textContent=phase==='live'?'⚡ ÚLTIMO DÍA CYBER':phase==='extended'?'⚡ CYBER EXTENDIDO':phase==='final'?'⚡ EXTENSIÓN FINAL':'GRACIAS POR ACOMPAÑARNOS';
      }
      if(changed)announcement.textContent=phase==='final'?'Última extensión hasta el domingo 11 de octubre a las 23:59, hora de Chile.':phase==='extended'?'¡Extendimos el Cyber hasta el viernes 9 de octubre a las 23:59, hora de Chile!':'El Cyber ha finalizado. Gracias por acompañarnos.';
      if(home&&phase==='live')say(w.speech,true);
      animate(phase==='live'?(home?'shout':'power'):'celebrate');
    }
    function tick() {
      if(root.hasAttribute('data-cf-campaign')){release();return;}
      if(!root.isConnected){clearInterval(ticker);clearInterval(ambient);clearTimeout(motionTimer);clearTimeout(speechTimer);sticky.remove();return;}
      var state=stateAt(now());
      if(state.phase!==phase)applyPhase(state);
      panel.toggleAttribute('data-cmomo-last-hour',state.lastHour);
      panel.querySelector('[data-cmomo-status]').textContent=state.lastHour?'⚡ ÚLTIMA HORA':words[phase].status;
      var values=[pad(state.hours),pad(state.minutes),pad(state.remainder)];
      digits.forEach(function(el,i){if(el.textContent!==values[i]){el.textContent=values[i];if(!first&&visible&&!document.hidden&&!reduce.matches&&panel.getAttribute('data-cmomo-motion')==='idle'){el.removeAttribute('data-tick');void el.offsetWidth;el.setAttribute('data-tick','');}}});
      timer.setAttribute('aria-label',state.hours+' horas, '+state.minutes+' minutos y '+state.remainder+' segundos restantes');
      stickyTime.textContent=values.join(':');
      if(phase==='ended')sticky.removeAttribute('data-visible');
      first=false;
    }
    function visibility() {
      if(root.hasAttribute('data-cf-campaign'))return;
      var rect=panel.getBoundingClientRect();visible=rect.bottom>0&&rect.top<innerHeight;
      panel.toggleAttribute('data-cmomo-offscreen',!visible||document.hidden);
      sticky.toggleAttribute('data-visible',rect.bottom<64&&phase!=='ended'&&!document.hidden);
      if(home)root.setAttribute('data-cyber-visible',String(root.getBoundingClientRect().bottom>0&&!document.hidden));
    }
    mascot.addEventListener('click',function(){
      if(panel.getAttribute('data-cmomo-motion')!=='idle')return;
      say(phase==='live'&&!home?'¡El tiempo no se detiene!':words[phase].speech,home||phase!=='live');
      animate(phase==='live'?(home?'shout':'tap'):'celebrate');
    });
    window.addEventListener('scroll',visibility,{passive:true});window.addEventListener('resize',visibility,{passive:true});
    document.addEventListener('visibilitychange',function(){tick();visibility();});
    function preference(){settle();}
    function release(){clearInterval(ticker);clearInterval(ambient);clearTimeout(motionTimer);clearTimeout(speechTimer);sticky.remove();window.removeEventListener('scroll',visibility);window.removeEventListener('resize',visibility);}
    document.addEventListener('cyber:final:activated',release,{once:true});
    if(reduce.addEventListener)reduce.addEventListener('change',preference);else reduce.addListener(preference);
    visibility();tick();
    var ticker=setInterval(tick,1000);
    var ambient=setInterval(function(){
      if(visible&&!document.hidden&&!reduce.matches&&panel.getAttribute('data-cmomo-motion')==='idle'){
        if(home&&phase==='live')say(words[phase].speech,true);
        animate(home?(phase==='live'?'shout':'celebrate'):(phase==='ended'?'celebrate':'tap'));
      }
    },28000);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
